import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Utils
import { getCustomerStatus } from 'common/utils/customerValidation'

// Constants
import { ACCOUNT_CATEGORY_OPTIONS } from 'common/constants/formOptions'

// Styled Components
import { TableWrapper, TabsWrapper } from './Accounts.elements'

// Views
import { Container, Tabs } from 'views/components'
import { App, Header, Sidebar, Content, PageWrapper, DirectorySubHeader } from 'views/layouts'
import { AccountsTable, DemoAccountsTable } from 'views/containers'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function Accounts(props) {
  const { filters, actions } = props

  const { accountDirectoryFilters } = filters
  const { setAccountDirectoryFilters } = actions

  const [csi] = useState(getCustomerStatus())
  return (
    <App>
      <Sidebar />
      <Header pageTitle="Directory" subHeader={<DirectorySubHeader />} />
      <Content>
        <PageWrapper>
          <Container>
            <TableWrapper>
              {csi === 1 && (
                <TabsWrapper>
                  <Tabs
                    pages={ACCOUNT_CATEGORY_OPTIONS}
                    page={accountDirectoryFilters?.account_category}
                    setPage={(v) => {
                      setAccountDirectoryFilters({ ...accountDirectoryFilters, account_category: v })
                    }}
                  />
                </TabsWrapper>
              )}
              {(csi === 1 || csi === 2) && <AccountsTable />}

              {csi !== 1 && csi !== 2 && <DemoAccountsTable />}
            </TableWrapper>
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
Accounts.defaultProps = {
  actions: {},
  ui: {},
  filters: {},
}

// Proptypes Validation
Accounts.propTypes = {
  actions: PropTypes.shape({
    setAccountDirectoryFilters: PropTypes.func,
  }),
  ui: PropTypes.shape({}),
  filters: PropTypes.shape({
    accountDirectoryFilters: PropTypes.shape({
      account_category: PropTypes.string,
    }),
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(Accounts)
